import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import ContentManager from 'src/componentes/content-manager';
import LoadingContainer from 'src/componentes/loading-container';
import RiscoPontoControleEdit from 'src/paginas/gestao-risco/risco/RiscoEditView/RiscoPontoControleEditView';

import BowTieDiagram from './components/BowTieDiagram';
import useBowTieData from './hooks/useBowTieData';

function GraficoBowTieView({
  riscoId,
  saved,
  disabled = false,
  onControlSaved,
}) {
  const intl = useIntl();
  const { values, isLoading, reload } = useBowTieData(riscoId, saved);

  const handleControlSaved = useCallback(() => {
    if (onControlSaved) {
      onControlSaved();
      return;
    }

    reload();
  }, [onControlSaved, reload]);

  const handleControlClick = useCallback(
    (control) => {
      if (disabled || !control?.riscoPontoControleId) return;

      ContentManager.addContent(
        <RiscoPontoControleEdit
          item={{ id: control.riscoPontoControleId }}
          parameters={{ riscoId }}
          afterSave={handleControlSaved}
          disabled={disabled}
        />
      );
    },
    [disabled, handleControlSaved, riscoId]
  );

  const hasDiagram = Boolean(values && (values.id || values.nome));

  return (
    <LoadingContainer isLoading={isLoading}>
      {!isLoading && !hasDiagram ? (
        <div className="tw:p-6 tw:text-[#60717d]">
          {intl.formatMessage({ id: 'label.nenhumRegistroFoiEncontrado' })}
        </div>
      ) : (
        <BowTieDiagram
          values={values}
          disabled={disabled}
          onControlClick={handleControlClick}
        />
      )}
    </LoadingContainer>
  );
}

export default GraficoBowTieView;
